import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { blogPosts as MOCK_POSTS, type BlogPost } from "@/mocks/blogPosts";

function dbToBlogPost(row: Record<string, unknown>): BlogPost {
  return {
    id: Number(row.id),
    title: String(row.title ?? ""),
    excerpt: String(row.excerpt ?? ""),
    content: String(row.content ?? ""),
    category: String(row.category ?? ""),
    author: String(row.author ?? "ISMAN Engineering Team"),
    date: String(row.published_date ?? ""),
    readTime: String(row.read_time ?? "5 min read"),
    image: String(row.image ?? ""),
    tags: Array.isArray(row.tags) ? (row.tags as unknown[]).map(String) : [],
  };
}

/**
 * Live blog posts from the shared ISMAN admin database (blog_posts, status=active).
 * Falls back to the bundled posts when empty or unreachable.
 */
export function useBlogPosts() {
  const [posts, setPosts] = useState<BlogPost[]>(MOCK_POSTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data, error } = await supabase
          .from("blog_posts")
          .select("*")
          .eq("status", "active")
          .order("id", { ascending: false });
        if (!active) return;
        if (!error && data && data.length > 0) {
          setPosts(data.map((r: Record<string, unknown>) => dbToBlogPost(r)));
        }
      } catch {
        /* keep mock fallback */
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return { posts, loading };
}
